<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableElasticsearchDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="elasticsearchDelmodal = true"
            v-hasPermission="['monitor:elasticsearchMonitor:delete']"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          @click="rowClick(row)"
          v-hasPermission="['monitor:elasticsearchMonitor:detail']"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="elasticsearchDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ domainName }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeElasticsearch()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableElasticsearchVue = {};
export default {
  name: "TableElasticsearch",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      elasticsearchDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      region: "",
      domainName: "",
      columns: [
        {
          title: this.$t("ElasticSearch.esDomain"),
          key: "domainName"
        },
        {
          title: this.$t("alarms.instance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.instance.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.instance.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      tableElasticsearchDate: []
    };
  },
  beforeCreate: function() {
    tableElasticsearchVue = this;
  },
  created() {
    eventBus.$on("esName", function(val) {
      tableElasticsearchVue.esName = val;
    });
    eventBus.$on("companyId", function(val) {
      tableElasticsearchVue.companyId = val;
    });
    eventBus.$on("tag", function(val) {
      tableElasticsearchVue.tag = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableElasticsearchVue.getElasticsearchData();
    },
    // 分页显示数据
    /****************************************************/
    getElasticsearchData: function() {
      //列表分页
      this.$api.elasticsearch
        .pageElasticsearch({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tableElasticsearchVue.companyId,
          domainName: tableElasticsearchVue.esName,
          tag: tableElasticsearchVue.tag
        })
        .then(res => {
          this.tableElasticsearchDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableElasticsearchVue.getElasticsearchData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableElasticsearchVue.getElasticsearchData();
    },
    // 销毁regionName
    beforeDestroy: function() {
      eventBus.$off("regionName");
      eventBus.$off("esName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.domainName = this.tableElasticsearchDate[index].domainName;
    },
    removeElasticsearch: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.elasticsearch
        .deleteElasticsearch("id", this.tableElasticsearchDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableElasticsearchVue.getElasticsearchData();
            this.isDisable = false;
            this.modal_loading = false;
            this.elasticsearchDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/elasticsearchDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          name: row.domainName,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/es/TableElasticsearch.vue